// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section {
  text-align: center;
}


.contact-button {
  background: #000;
  color: #fff;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  transition: 0.3s;
}
  
.contact-button:hover {
  background: #444;
}`, "",{"version":3,"sources":["webpack://./src/Sections/Contact/Contact.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".contact-section {\n  text-align: center;\n}\n\n\n.contact-button {\n  background: #000;\n  color: #fff;\n  padding: 12px 24px;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: 0.3s;\n}\n  \n.contact-button:hover {\n  background: #444;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
